// Definición de defaults

export const defaultTipoDocumentoFirma: TipoDocumentoFirmaProps = {
    idTipoDocumentoFirma:   0,
    descripcion:            '',
    activo:                 false,
}

// Creación de interfaces

export interface TipoDocumentoFirmaProps   {
    idTipoDocumentoFirma:   number;
    descripcion:            string;
    activo:                 boolean;
}